<template>
  <v-dialog v-model="fullStatisticDialog" width="1500" persistent>
    <v-card class="pa-5">
      <v-toolbar flat class="mb-5">
        <v-spacer></v-spacer>
        <p class="title">Last 100 Articles</p>
        <v-spacer></v-spacer>
        <v-btn color="error"  class="ma-2" outlined icon large @click="closeDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card>
        <v-data-table
          :headers="headers"
          :items="articleData"
          class="elevation-1"
        >
          <template v-slot:item.Created="{ item }">
            {{ item.Created | moment('LL')  }}
          </template>
          <template v-slot:item.Published="{ item }">
            <p v-if="item.Published == 1" style="color:green;">Yes</p>
            <p v-else style="color:red;">No</p>
          </template>
        </v-data-table>
      </v-card>
      <!-- <pre>{{articleData}}</pre> -->
    </v-card>
  </v-dialog>
</template>

<script>
// Import funcitons from store.js (vuex)
import { mapActions } from "vuex";
export default {
  data(){
    return{
      headers:[
        {text: 'Name', value: 'Nickname'},
        {text: 'Article Title', value: 'Title'},
        // {text: 'Description', value: 'Content'},
        {text: 'Created', value: 'Created'},
        {text: 'Published', value: 'Published'},
        {text: 'Article Id', value: 'id'},
      ],
      fullStatisticDialog : false,
      articleData: [],
    }
  },
  methods: {
    openDialog() {
      this.fullStatisticDialog = true;
    },
    closeDialog(){
      this.fullStatisticDialog = false;
    },

     // Import these functions from store.js
    ...mapActions([
      "GET_LAST_ARTICLES"
    ]),
    // Get all the data, including CreatedDays which through moment will display in correct form.
    getAllArticleData(){
      this.GET_LAST_ARTICLES().then(response => {
        this.articleData = response;
      })
    }
  },
  // Run this function when page are loaded
  mounted() {
    this.getAllArticleData();
  }
}
</script>
